import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Defects from "./components/defects/Defects";
import Notifications from "./components/notifications/Notifications";
import Machinerecords from "./components/machinerecords/Machinerecords";
import Workrecords from "./components/workrecords/Workrecords";
import DefectsList from "./components/defectslist/DefectsList";
import reportWebVitals from "./reportWebVitals";
import { LicenseManager } from "ag-grid-enterprise";
import { Provider, useSelector } from "react-redux";
import { setupStore, RootState, AppDispatch } from "./redux/store";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { Auth, Amplify } from "aws-amplify";
//import {config} from './aws-exports';
import Login from "./Login";

import { getToken } from "./utils/utils";
import { fetchPlantProcMach } from "./redux/procsSlice";
import { fetchDefectTypes } from "./redux/defectTypesSlice";
import { fetchMember } from "./redux/memberSlice";
import { fetchSuspensionReasons } from "./redux/suspensionReasonsSlice";
import { feathUserInfo, logout } from "./redux/userSlice";

//Amplify.configure(config);

import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Alert } from "./components/ui/Alert";

const store = setupStore();

// AG Grid ライセンスキーを環境変数から設定
// LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE_KEY || "");
LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-069410}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Nakajima_Glass}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_October_2025}____[v3]_[01]_MTc2MDQ4MjgwMDAwMA==01a1f047cd21c077c7f1ccfd28481864"
);

// Amplifyの設定
if (localStorage.getItem("userType") === "google") {
  // Cognitoでログインしている場合
  Amplify.configure({
    Auth: {
      region: process.env.REACT_APP_GOOGLE_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_GOOGLE_COGNITO_USER_POOL_ID,
      userPoolWebClientId:
        process.env.REACT_APP_GOOGLE_COGNITO_USER_POOL_WEB_CLIENT_ID,
      oauth: {
        domain: process.env.REACT_APP_GOOGLE_COGNITO_DOMAIN,
        scope: ["openid"],
        redirectSignIn: process.env.REACT_APP_AUTH_REDIRECT_SIGN_IN,
        redirectSignOut: process.env.REACT_APP_AUTH_REDIRECT_SIGN_OUT,
        responseType: "code",
      },
    },
  });
} else {
  Amplify.configure({
    // Cognitoでログインしている場合
    Auth: {
      region: process.env.REACT_APP_AUTH_REGION,
      userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID,
      oauth: {
        scope: ["openid"],
        redirectSignIn: process.env.REACT_APP_AUTH_REDIRECT_SIGN_IN,
        redirectSignOut: process.env.REACT_APP_AUTH_REDIRECT_SIGN_OUT,
        responseType: "code",
      },
      identity_provider: "COGNITO",
    },
  });
}

// ログイン済みか判定
(async function () {
  try {
    const currentSession = await Auth.currentSession().then();
    console.log(currentSession);
    if (currentSession.isValid()) {
      localStorage.setItem("isLogged", "false");
    } else {
      localStorage.setItem("isLogged", "true");
    }
  } catch (error: any) {
    localStorage.setItem("isLogged", "false");
  }
})();

/*
import { type ResponseResolver, HttpResponse } from 'msw';
import { setupWorker } from 'msw/browser';
const mockEvents: ResponseResolver = () => {
  return HttpResponse.json({});
};
*/
// APIモック
async function enableMocking() {
  if (process.env.NODE_ENV !== "development") {
    // ビルド時、モックサーバを起動しなくする
    return;
  }

  const { worker } = await import("./mocks/browser");
  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  console.log("enableMocking");
  //  return worker.start()
  return worker.start({ onUnhandledRequest: "bypass" });
}

const RootComponent = () => {
  const isLogged = useSelector((state: RootState) => state.user.isLogged);
  const dispatch: AppDispatch = useDispatch();

  const signout = async () => {
    try {
      dispatch(logout());
      await Auth.signOut();
    } catch (error) {
      console.log("Error signing out: ", error);
    }
  };

  const path = useLocation().pathname;
  const query = new URLSearchParams(useLocation().search);

  useEffect(() => {
    console.log("path", path);
    console.log("query", query);
    if (path === "/") {
      if (
        query.get("plant_code") === null &&
        query.get("proc_code") === null &&
        query.get("mach_code") === null
      ) {
        localStorage.setItem("plant_code", "");
        localStorage.setItem("proc_code", "");
        localStorage.setItem("mach_code", "");
      } else {
        localStorage.setItem("plant_code", query.get("plant_code") ?? "");
        localStorage.setItem("proc_code", query.get("proc_code") ?? "");
        localStorage.setItem("mach_code", query.get("mach_code") ?? "");
      }
    }
  }, [dispatch]);

  useEffect(() => {
    const getMasterData = async () => {
      const token = await getToken();
      if (token === "" && isLogged) {
        await signout();
        return;
      }
      if (isLogged) {
        // ログインユーザ名取得
        dispatch(feathUserInfo());
        // 工場・加工・機械のマスタデータを取得
        dispatch(fetchPlantProcMach());
        // 作業状況一覧用レイアウト定義を取得
        // dispatch(fetchProcListLayout());
        // 不良理由区分一覧取得を取得
        dispatch(fetchDefectTypes());
        // 社員のマスタデータを取得
        dispatch(fetchMember());
        // 中断理由取得
        dispatch(fetchSuspensionReasons());
      }
    };
    getMasterData();
  }, [isLogged, dispatch]);

  return (
    <>
      <Routes>
        <Route
          path="/login"
          element={isLogged ? <Navigate to="/" /> : <Login />}
        />
        <Route
          path="/"
          element={isLogged ? <App /> : <Navigate to="/login" />}
        />
        <Route
          path="/defects"
          element={isLogged ? <Defects /> : <Navigate to="/login" />}
        />
        <Route
          path="/notifications"
          element={isLogged ? <Notifications /> : <Navigate to="/login" />}
        />
        <Route
          path="/machinerecords"
          element={isLogged ? <Machinerecords /> : <Navigate to="/login" />}
        />
        <Route
          path="/workrecords"
          element={isLogged ? <Workrecords /> : <Navigate to="/login" />}
        />
        <Route
          path="/defectslist"
          element={isLogged ? <DefectsList /> : <Navigate to="/login" />}
        />
      </Routes>
      <Alert />
    </>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

enableMocking().then(() => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <Router>
          <RootComponent />
        </Router>
      </Provider>
    </React.StrictMode>
  );
});
// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <Router>
//         <Routes>
//           <Route path="/" element={<App />} />
//           <Route path="/defects" element={<Defects />} />
//           <Route path="/notifications" element={<Notifications />} />
//         </Routes>
//       </Router>
//     </Provider>

//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
